
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Avatar, FloatButton, Space, Table} from "antd";
import Modal from "antd/es/modal";
import {use} from "i18next";
import axios from "axios";
import {Link} from "react-router-dom";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";
import Icon from "../Icon";

let last;

export default (prop) => {

    const {t} = useTranslation()
    const [isOpen, setIsOpen] = useState(false);
    const [data, setData] = useState([]);

    useEffect(() => {

        for (let i = 0; i < 10; i++) {
            data[i] = {key: i + 1, commonHeroes: []}
        }

        const run = () => {
            axios.post(`${axios.defaults.localURL}lobbyPlayerList`).then(res => {
                if (res && res !== last) {
                    last = res
                    axios.post(`player/lobbyPlayerList`, {
                        data: res
                    }).then(res => {
                        for (const playerIndex in res) {
                            data[playerIndex] = res[playerIndex]
                            data[playerIndex].key = Number(playerIndex) + 1
                        }
                        setData([...data])
                    })
                }

            })
        }
        let key = -1
        let key2 = -1
        if (isOpen) {
            run()
            key2 = setTimeout(() => {
                setIsOpen(false)
            },1000 * 60 * 5)
            key = setInterval(() => {
               run()
            }, 1000)
        }

        return () => {
            clearInterval(key)
            clearInterval(key2)
        }

    }, [isOpen])

    const columns = [
        {
            key: 'key',
            dataIndex: 'key',
            title: "ID",
            render: (key) => <b>{key}</b>,
            align: 'center',
        },
        {
            key: 'player',
            dataIndex: 'player',
            title: t('players'),
            render: (_, p) =>
                <Link to={`/player/${p.handle}`} >
                    <Space>
                        {
                            p.pfp > 0 ? <Avatar src={`https://www.aslucky.club/file/touhou/pfp/${p.handle}.png?r=${p.pfp}`} shape="square" size={32} icon={<UserOutlined />} />
                                : <Avatar shape="square" size={32} icon={<UserOutlined />} />
                        }
                        <span>{p.clanTag ? `<${p.clanTag}>` : ''}{p.name}</span>
                    </Space>
                </Link>,
            align: 'left',
            width: 400
        },
        {
            key: 'mmr',
            dataIndex: 'mmr',
            title: t('mmr'),
            render: (mmr, p) => <div style={{ position: "relative" }}>
                <b>{mmr == -99999 ? t('noRank') : mmr}</b>
            </div>,
            align: 'center',
            width: 80
        },
        {
            key: 'mmrMax',
            dataIndex: 'mmrMax',
            title: t('mmrMax'),
            render: (mmrMax, p) => <div style={{ position: "relative" }}>
                <b>{mmrMax}</b>
            </div>,
            align: 'center',
            width: 120
        },
        {
            key: 'wins',
            dataIndex: 'wins',
            title: t('wins'),
            align: 'center',
            width: 80
        },
        {
            key: 'losses',
            dataIndex: 'losses',
            title: t('losses'),
            align: 'center',
            width: 80
        },
        {
            key: 'exitCount',
            dataIndex: 'exitCount',
            title: t('escape'),
            align: 'center',
            width: 80
        },
        {
            key: 'commonHeroes',
            dataIndex: 'commonHeroes',
            title: t('commonHeroes'),
            align: 'center',
            width: 160,
            render: (_, p) => p.commonHeroes.map((p) => <Icon type={'hero'} key={p} name={p} size={28} />),
        },
    ]


    return <>
        <Modal width={860} style={{}} title="" open={isOpen} onCancel={() => setIsOpen(false)} cancelButtonProps={{style: {display: "none"}}} okButtonProps={{style: {display: "none"}}}>
            <div style={{padding: "20px"}}>
                <Table size={'small'} columns={columns} pagination={false} dataSource={data}/>
            </div>
        </Modal>
        <FloatButton style={{ }} onClick={() => setIsOpen(true)} />
    </>

}
